export const UPDATE_DURATION = 'UPDATE_DURATION';
export const UPDATE_SOUND_TYPE = 'UPDATE_SOUND_TYPE';
export const UPDATE_OCTAVE = 'UPDATE_OCTAVE';
export const SET_ARP_MODE = 'SET_ARP_MODE';
export const TOGGLE_ARP_MODE = 'TOGGLE_ARP_MODE';
export const RESET_ARP_ARRAY = 'RESET_ARP_ARRAY';
export const ADD_NOTE_TO_ARP = 'ADD_NOTE_TO_ARP';
// export const REMOVE_NOTE_FROM_ARP = 'REMOVE_NOTE_FROM_ARP';
